

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";


import { Header } from '../../Components/Layout/Header.jsx'

import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import TwoFactorAuth from '../../Components/Account/TwoFactorAuth.jsx'


export class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirectToReferrer: false,
            need2FA: false,
            refID2FA: null,
            code2FA: ""
        };

        this.login = this.login.bind(this);
        this.checkLogin = this.checkLogin.bind(this);
        this.registracijaClick = this.registracijaClick.bind(this);

        this.form = React.createRef();
        this.username = React.createRef();
        this.password = React.createRef();
        this.code2FA = React.createRef();
        this.poruka = React.createRef();
        this.porukaText = React.createRef();
        this.prijava = React.createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.props.showMenuFn(false);

        this.checkLogin(false);
        var routeState = this.props.route.location.state || {};
        var username = routeState.username || "";
        var failedLogin = routeState.failedLogin || false;

        if (username)
            this.username.current.value = username;
        if (failedLogin) {
            this.poruka.current.className = "";
            this.porukaText.current.innerText = routeState.loginError || "Dogodila se pogreška. Pokušajte ponovno.";
        } else {
            this.username.current.focus();
        }


        this.autoFillChecker = setTimeout(() => {
            this.checkLogin();
        }, 750);
    }

    componentWillUnmount() {
        clearInterval(this.autoFillChecker);
    }


    login(e) {
        e.preventDefault();
        var username = this.username.current.value;
        var password = this.password.current.value;
        this.prijava.current.disabled = true;

        this.props.showLoadingFn(true);
        var that = this;

        let ttId = casino.utils.getCookie("_tdid");
        if (ttId == null) {
            ttId = casino.utils.uuidv4();
            casino.utils.setCookie("_tdid", ttId, 180);
        }

        casino.repos.sessionRepo.create(username, password, ttId).then(
            function (login) {
                that.props.showLoadingFn(false);
                if (!login.ok && !login.need2FA) {
                    that.poruka.current.className = "";
                    that.password.current.value = "";
                    that.porukaText.current.innerText = login.loginError || "Dogodila se pogreška. Pokušajte ponovno.";
                    that.checkLogin(false);
                }
                else if (login.ok && login.need2FA) {
                    that.setState({
                        need2FA: true,
                        refID2FA: login.refID2FA
                    });
                }


                else {
                    that.props.updateUserFn(login.sesija.igrac, login.sesija.sesijaId);
                    setTimeout(that.props.getNotifikacijeFn, 2000);
                    that.setState({ redirectToReferrer: true });
                    if (typeof ga !== 'undefined') // google analytics
                        ga('send', { hitType: 'event', eventCategory: 'Actions', eventAction: 'UspjesnaPrijava' });

                    //Google tag manager
                    casino.utils.createGoogleTagManagerEvent({
                        'event': 'userID',
                        'user_id': login.sesija.igrac.token,
                        'accountID': login.sesija.igrac && login.sesija.igrac.publicID || ""
                    });


                    //GA360
                    casino.utils.createGoogleTagManagerEvent({
                        'userInformation': {
                            'user.profile.accountID': login.sesija.igrac && login.sesija.igrac.publicID || "",
                            'user.profile.bal': login.sesija.igrac != null && login.sesija.igrac.casinoRaspolozivoZaIsplatu != null ? login.sesija.igrac.casinoRaspolozivoZaIsplatu : 0,
                            'user.profile.currency': "EUR",
                            'user.profile.country': "HR",
                            'user.session.geoIPCountry': casino.config.iPAddress,
                            'user.hasPositiveBalance': login.sesija.igrac && login.sesija.igrac.casinoRaspolozivoZaIsplatu > 0 ? true : false,
                            'user.isAuthenticated': true,
                            'user.isExisting': login.sesija.igrac ? true : false
                        }
                    });

                    //GA360
                    var browserScreenResolution = window.screen.width + 'x' + window.screen.height;
                    var browserOrientation = window.matchMedia("(orientation: portrait)").matches ? 'PORTRAIT' : 'LANDSCAPE';

                    casino.utils.createGoogleTagManagerEvent({
                        'browserInformation': {
                            'browser.userAgent': casino.config.userAgent,
                            'page.culture': casino.config.cultureInfo,
                            'page.frontend': "mobile",
                            'page.domain': "https://mcasino.supersport.hr/",
                            'page.medium': "mobile web",
                            'browser.orientation': browserOrientation,
                            'browser.screenResolution': browserScreenResolution
                        }
                    });
                }
            });
    }




    checkLogin(hideMsg) {
        var username = this.username.current.value;
        var password = this.password.current.value;

        if (hideMsg !== false)
            this.poruka.current.className = "hidden";

        this.prijava.current.disabled = !(username.length > 3 && password.length > 3);
    }


    registracijaClick() {
        if (typeof ga !== 'undefined') // google anayltics
            ga('send', { hitType: 'event', eventCategory: 'Clicks', eventAction: 'Registracija Click' });

        //Facebook pixel
        //fbq('track', 'CompleteRegistration');
    }

    render() {
        var redirectToReferrer = this.state.redirectToReferrer || false;
        var routeState = this.props.route.location.state || {};
        var from = routeState.from || this.props.getHomePathFn(this.props.route.location);

        return <div>
            {redirectToReferrer && (<Redirect to={from} />)}

            <Header key="header" {...this.state} {...this.props} userHeader="true" headerText="Prijava" headerBackUrl="/"></Header>

            <div id="page-wrapper" className="login-page white padding-2p-on-mobile border-on-tablet margin-1p-on-tablet">

                {!this.state.need2FA && <>
                    <div className="welcome">Dobrodošao natrag 👋 </div>
                    <div className="tekst">Prijavi se i sudjeluj u uzbudljivim igrama i neodoljivim promocijama!  🎰</div>
                    
                    <div className="padding-sides-medium">
                        <form ref={this.form}>

                            <span> Email ili nadimak</span>
                            <input className="input" type="text" ref={this.username} placeholder="nadimak ili email" onChange={this.checkLogin} onKeyPress={this.checkLogin} />
                            <span>Lozinka</span><input className="input" type="password" ref={this.password} placeholder="lozinka" onChange={this.checkLogin} onKeyPress={this.checkLogin} />




                            <div ref={this.poruka} className="hidden">
                                <div className="login-error-message">
                                    <span className="icon ico-alert"></span><span ref={this.porukaText}></span>
                                </div>
                            </div>
                            <button ref={this.prijava} className="btn fill large login" onClick={this.login}>Prijavi me</button>
                            <div className="clearfix">
                                <CasinoLink href={casino.config.urls.zaboravljenaLozinka}>
                                    <img src="content/images/assets/forgotPassword.png" /><span>Zaboravio sam lozinku</span>
                                </CasinoLink>
                                <a href={casino.config.urls.registracija} onClick={this.registracijaClick}>
                                    <img src="content/images/assets/register.png" /><span>Želim se registrirati</span>
                                </a>
                            </div>
                            <span>
                                Zabranjeno je klađenje državljanima SAD-a i svima koji posjeduju radnu dozvolu u SAD-u. Ako se trenutačno nalazite izvan Hrvatske, molimo Vas da se upoznate i ponašate u skladu s važećom regulativom područja u kojem se nalazite.
                            </span>
                        </form>
                    </div>
                </>}
                {this.state.need2FA && <TwoFactorAuth refID2FA={this.state.refID2FA} {...this.props} />}
            </div>
        </div>

    }
};
